import type { ITag } from './tag.interfaces';
import type { IMarket } from './market.interfaces';

export enum SortDirection {
  Ascending = 'ASC',
  Descending = 'DES',
}

export type IMarketAndTag = ITag & IMarket;
